import { v4 as uuidv4 } from 'uuid';
export const bodyItems = {
    properties:[{
        label:'General',
        items:[{
            type:'Color',
            label:'Text Color',
            path:'.attributes.style',
            keyParam:'color',
        },{
            type:'BackgroundColor',
            label:'Background Color',
            path:'.attributes.style',
            keyParam:'backgroundColor',
        },{
            type:'Alignment',
            alignTypes:['left','right','justify','center'],
            path:'.attributes.style',
            label:'Content Alignment',
            keyParam:'contentAlign',
        },{
            type:'FontFamily',
            path:'.attributes.style',
            label:'Font Family',
            keyParam:'fontFamily',
        },{
            type:'FontWeight',
            path:'.attributes.style',
            label:'Font Weight',
            keyParam:'fontWeight',
        },
        {
            type:'Padding',
            label:'Padding',
            keyParam:'padding',
            path:'.attributes.style',
        },
        ]
    },{
        label:'Dimension',
        items:[
            {
                type:'Paper',
                label:'Paper Size',
                path:'.attributes.style',
                keyParam:'width',
            }   
        ]
    }]
}

export const  elementsItems = [
    {
        type:'Grid',
        label:'Grid',
        name:'div',
        children:[{
            id:uuidv4(),
            type:'Column',
            name:'div',
            children:[],
            attributes:{
                style:{
                    width:'100%',
                    padding:'10px 10px 10px 10px'
                }
            },
            properties:[                
                {
                    type:'Padding',
                    label:'Padding',
                    keyParam:'padding',
                    path:'.attributes.style',
                },
                {
                    type:'BackgroundColor',
                    label:'Background Color',
                    keyParam:'backgroundColor',
                    path:'.attributes.style',
                }
            ],
        }],
        attributes:{
            style:{
                display: 'flex',
                flexWrap:'wrap',
                // marginRight:'-15px',
                // marginLeft: '-15px'
            }
        },
        svgIcon:'GridIcon',
        properties:[
            {
                type:'GridSystem',
                label:'Columns',
                keyParam:'children',
                path:'',
            },
            {
                type:'Padding',
                label:'Padding',
                keyParam:'padding',
                path:'.attributes.style',
            },
            {
                type:'BackgroundColor',
                label:'Background Color',
                keyParam:'backgroundColor',
                path:'.attributes.style',
            }
        ],
        acceptDestination:[]
    },    
    {
        type:'Heading',
        name:'h1',
        label:'Heading',
        data:'Heading',
        svgIcon:'HeadingIcon',
        attributes:{style:{}},
        properties:[{
            type:'Headings',
            headingTypes:['h1','h2','h3','h4','h5','h6'],
            label:'Heading Type',
            path:'.attributes.style',
            // path:'.attributes.style',
            keyParam:'name',
        },{
            type:'Color',
            label:'Text Color',
            path:'.attributes.style',
            keyParam:'color',
        },{
            type:'Alignment',
            alignTypes:['left','right','justify','center'],
            path:'.attributes.style',
            label:'Text Alignment',
            keyParam:'textAlign',
        },{
            type:'FontFamily',
            path:'.attributes.style',
            label:'Font Family',
            keyParam:'fontFamily',
        },{
            type:'FontWeight',
            path:'.attributes.style',
            label:'Font Weight',
            keyParam:'fontWeight',
        },{
            type:'FontStyle',
            path:'.attributes.style',
            label:'Font Style',
            keyParam:'fontStyle',
        }],
        acceptDestination:[]
    },
    {
        type:'Text',
        label:'Text',
        name:'p',
        data:'This is a new Text block. Change the text',
        svgIcon:'TextIcon',
        attributes:{style:{}},
        properties:[{
            type:'Color',
            label:'Text Color',
            path:'.attributes.style',
            keyParam:'color',
        },{
            type:'Alignment',
            alignTypes:['left','center','right','justify'],
            path:'.attributes.style',
            label:'Text Alignment',
            keyParam:'textAlign',
        },{
            type:'FontFamily',
            path:'.attributes.style',
            label:'Font Family',
            keyParam:'fontFamily',
        },{
            type:'FontWeight',
            path:'.attributes.style',
            label:'Font Weight',
            keyParam:'fontWeight',
        },{
            type:'FontSize',
            path:'.attributes.style',
            label:'Font Size',
            keyParam:'fontSize',
        },{
            type:'FontStyle',
            path:'.attributes.style',
            label:'Font Style',
            keyParam:'fontStyle',
        }],
        acceptDestination:[]
    },
    {
        type:'Image',
        label:'Image',
        name:'img',
        svgIcon:'ImageIcon',
        attributes:{
            style:{
                //width:'100%',
                //height:'auto',
                backgroundSize:'cover',
                textAlign:'center'
            },
            width:'auto',
            height:'100'
        },
        properties:[
            {
                type:'Upload',
               // alignTypes:['left','center','right'],
                path:'.attributes.style',
                label:'Upload Image',
                keyParam:'src',  
            },
            {
                type:'Alignment',
                alignTypes:['left','center','right'],
                path:'.attributes.style',
                label:'Image Alignment',
                keyParam:'textAlign',
            },
            {
                type:'Padding',
                label:'Padding',
                keyParam:'padding',
                path:'.attributes.style',
            },
            {
                type:'Dimension',
                label:'Dimension',
                keyParam:'dimension',
                path:'.attributes.style',
            },
        ],
        acceptDestination:[]
    },
    {
        type:'Button',
        svgIcon:'ButtonIcon',
        label:'Button',
        name:'a',
        data:'Button Text',
        attributes:{
            style:{                
                padding:'10px 25px 10px 25px',
                fontSize:'14px',
                textAlign:'center',
                backgroundColor:'#000000',
                color:'#ffffff',
                fontWeight:'bold',
                display:'inline-flex'
            },
            href:'#',
            target:'_blank'
        },
        properties:[
            {
                type:'Link',
                label:'Href',
                keyParam:'href',
                path:'.attributes.href',  
            },
            {
                type:'Padding',
                label:'Inner Padding',
                keyParam:'padding',
                path:'.attributes.style',
            },
            {
                type:'Color',
                label:'Text Color',
                path:'.attributes.style',
                keyParam:'color',
            },
            {
                type:'BackgroundColor',
                label:'Background Color',
                keyParam:'backgroundColor',
                path:'.attributes.style',
            },
            {
                type:'Alignment',
                alignTypes:['left','center','right'],
                path:'.attributes.style',
                label:'Button Alignment',
                keyParam:'textAlign',
            },
            {
                type:'FontFamily',
                path:'.attributes.style',
                label:'Font Family',
                keyParam:'fontFamily',
            },
            {
                type:'FontWeight',
                path:'.attributes.style',
                label:'Font Weight',
                keyParam:'fontWeight',
            },
            {
                type:'FontSize',
                path:'.attributes.style',
                label:'Font Size',
                keyParam:'fontSize',
            },
        ],        
        acceptDestination:[]
    },
    {
        type:'Divider',
        label:'Divider',
        svgIcon:'DividerIcon',
        name:'div',
        data:'',
        attributes:{
            style:{
                borderTop:'1px solid #000000',
                width:'100%'
                //padding:'10px 0px 10px 0px'
            }, 
            borderStyle:'solid',
            color:'#000000'           
        },
        properties:[
            {
                type:'Divider',
                label:'Border',
                path:'.attributes.style',
                keyParam:'borderTop',
            }
        ],        
        acceptDestination:[]
    }
]

export const scmTagElements = [
    {
        type:'SCM:INPUT',
        label:'INPUT',
        name:'scm:inputtext',        
        data:'{replace value}',
        attributes:{style:{}},
        properties:[
            {
                type:'SCM:NAME',
                path:'',
                label:'SCM INPUT',
                keyParam:'SCM:NAME',
            }
        ]
    },
    {
        type:'SCM:OUTPUT',
        label:'OUTPUT',
        name:'scm:outputtext',
        data:'{replace value}',
        attributes:{style:{}},
        properties:[
            {
                type:'SCM:NAME',
                path:'',
                label:'SCM OUTPUT',
                keyParam:'SCM:NAME',
            }
        ]
    },
    {
        type:'SCM:DATATABLE',
        label:'DATATABLE',
        name:'scm:dataTable',
        data:'',
        conditions:[],
        attributes:{
            style:{},
            entries:'',
            var:''
        },
        properties:[
            {
                type:'Text',
                label:'Entries',
                keyParam:'entries',
                path:'.attributes',
            },
            {
                type:'Text',
                label:'Var',
                keyParam:'var',
                path:'.attributes',
            },
        ],
        children:[
            {
                id:uuidv4(),
                type:'Column',
                name:'div',
                children:[],
                attributes:{
                    style:{
                        width:'100%',
                        padding:'10px 10px 10px 10px'
                    }
                },
                properties:[                
                    {
                        type:'Padding',
                        label:'Padding',
                        keyParam:'padding',
                        path:'.attributes.style',
                    },
                    {
                        type:'BackgroundColor',
                        label:'Background Color',
                        keyParam:'backgroundColor',
                        path:'.attributes.style',
                    }
                ],
            }
        ]
    },
    {
        type:'SCM:DECISION',
        label:'DECISION',
        name:'scm:decision',
        data:'',
        conditions:[],
        attributes:{style:{}},
        properties:[
            {
                type:'Padding',
                label:'Padding',
                keyParam:'padding',
                path:'.attributes.style',
            },
        ],
        children:[
            {
                id:uuidv4(),
                type:'Column',
                name:'div',
                children:[],
                attributes:{
                    style:{
                        width:'100%',
                        padding:'10px 10px 10px 10px'
                    }
                },
                properties:[                
                    {
                        type:'Padding',
                        label:'Padding',
                        keyParam:'padding',
                        path:'.attributes.style',
                    },
                    {
                        type:'BackgroundColor',
                        label:'Background Color',
                        keyParam:'backgroundColor',
                        path:'.attributes.style',
                    }
                ],
            }
        ]
    },
    {
        type:'SCM:IF',
        label:'IF',
        name:'scm:if',
        data:'',
        conditions:[],
        attributes:{style:{}},
        properties:[
            {
                type:'SCM:CONDITION',
                path:'',
                label:'SCM IF',
                keyParam:'SCM:CONDITION',
            }
        ],
        children:[
            {
                id:uuidv4(),
                type:'Column',
                name:'div',
                children:[],
                attributes:{
                    style:{
                        width:'100%',
                        padding:'10px 10px 10px 10px'
                    }
                },
                properties:[                
                    {
                        type:'Padding',
                        label:'Padding',
                        keyParam:'padding',
                        path:'.attributes.style',
                    },
                    {
                        type:'BackgroundColor',
                        label:'Background Color',
                        keyParam:'backgroundColor',
                        path:'.attributes.style',
                    }
                ],
            }
        ]
    },
    {
        type:'SCM:ELSEIF',
        label:'ELSE IF',
        name:'scm:elseIf',
        data:'',
        conditions:[],
        attributes:{style:{}},
        properties:[
            {
                type:'SCM:CONDITION',
                path:'',
                label:'SCM ELSE IF',
                keyParam:'SCM:CONDITION',
            }
        ],
        children:[
            {
                id:uuidv4(),
                type:'Column',
                name:'div',
                children:[],
                attributes:{
                    style:{
                        width:'100%',
                        padding:'10px 10px 10px 10px'
                    }
                },
                properties:[                
                    {
                        type:'Padding',
                        label:'Padding',
                        keyParam:'padding',
                        path:'.attributes.style',
                    },
                    {
                        type:'BackgroundColor',
                        label:'Background Color',
                        keyParam:'backgroundColor',
                        path:'.attributes.style',
                    }
                ],
            }
        ]
    }
]